export interface Phone {
    label: string
    value: string
}

export interface ContactsPerson {
    pictureURL?: string
    role: string
    name: string
    phone: Phone
    email: string
}

export interface ContactsCompany {
    pictureURL?: string
    name: string
    street: string
    city: string
    country: string
    nip: string
    website: string
    phone: Phone
    email: string
}

export interface ContactsPage {
    persons: ContactsPerson[]
    companies: ContactsCompany[]
}

export var machineRentPageContacts: ContactsPage = {
    persons: [{
        pictureURL: '/public/env/img/contact/wojciech-kornasiewicz.jpg',
        role: 'Regional Manager',
        name: 'Wojciech Kornasiewicz',
        phone: {
            label: '+48 570 400 839',
            value: '+48570400839'
        },
        email: 'wojciech.kornasiewicz@multiawp.pl'
    }, {
        pictureURL: '/public/env/img/contact/krzysztof-mieszkow.jpg',
        role: 'Sales Manager',
        name: 'Krzysztof Mieszków',
        phone: {
            label: '+48 570 400 938',
            value: '+48570400938'
        },
        email: 'krzysztof.mieszkow@multiawp.pl'
    }],
    companies: []
}

export var machineBuyPageContacts: ContactsPage = machineRentPageContacts

export var callPageContacts: ContactsPage = {
    // persons: [{
    //     phone: {
    //         label: '+48 570 400 943',
    //         value: '+48570400943'
    //     },
    //     email: 'sales@multiawp.pl'
    // }],
    persons: [],
    companies: [{
        // pictureURL: '/public/env/img/logo/logo.png',
        name: 'MULTI AWP Sp. z o.o.',
        street: 'ul. Kolorowa 5',
        city: '05-092 Izabelin Dziekanówek',
        country: 'Polska',
        nip: '531-171-17-57',
        website: 'www.multiawp.pl',
        phone: {
            label: '+48 570 400 943',
            value: '+48570400943'
        },
        email: 'sales@multiawp.pl'
    }]
}

export var supportPageContacts: ContactsPage = {
    persons: [{
        pictureURL: '/public/env/img/contact/marcin-skibinski.png',
        name: 'Marcin Skibiński',
        role: 'Super Administrator',
        phone: {
            label: '+48 519 343 232',
            value: '+48519343232'
        },
        email: 'marcin@evoltag.pl'
    }],
    companies: []
}